export class MockHttpClient {
    constructor() {
        this.getResponse = () => { };
    }
    async get(url) {
        return this.getResponse();
    }
    async post(url, body, httpClientOptions) {
        throw new Error('Method not implemented.');
    }
    delete(url, httpClientOptions) {
        throw new Error('Method not implemented.');
    }
}
